import { AnnotationId, type DocumentId } from "@curriculum-studio/core";
import { HttpClient, HttpClientRequest, HttpClientResponse } from "@effect/platform";
import { Data, Effect, Schema } from "effect";

// The strip half of the REST client (U11): `POST /api/strip` ({ documentId, annotationId }), through
// `@effect/platform`'s `HttpClient` so the IO stays in Effect. The success body is decoded with
// `core` boundary `Schema`s. A 409 means the annotation was already decided between render and click
// (a concurrent Gate-1 keep/reject/close won the race, ADR-0044 — there is no classify pass anymore,
// so the only way strip loses the race is a terminal decision beating it) — surfaced as a tagged
// `StripAlreadyDecided` so the UI can tell the Expert the finding is no longer theirs to retract
// rather than silently failing.

const StripSuccess = Schema.Struct({
  status: Schema.Literal("ok"),
  annotationId: AnnotationId,
});

export class StripAlreadyDecided extends Data.TaggedError("StripAlreadyDecided")<{
  readonly message: string;
}> {}

export const strip = (documentId: DocumentId, annotationId: AnnotationId) =>
  Effect.gen(function* () {
    const client = yield* HttpClient.HttpClient;
    const response = yield* client.execute(
      HttpClientRequest.post("/api/strip").pipe(
        HttpClientRequest.bodyUnsafeJson({ documentId, annotationId }),
      ),
    );
    if (response.status === 409) {
      return yield* Effect.fail(
        new StripAlreadyDecided({
          message:
            "This annotation has already been decided at the gate and can no longer be retracted.",
        }),
      );
    }
    return yield* HttpClientResponse.schemaBodyJson(StripSuccess)(response);
  }).pipe(Effect.scoped);
